import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { Box } from "@material-ui/core/";
import Chips from './component/Chips'
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
    table: {
        boxSizing: "border-box",
        paddingBottom:'40px',
        border: '1px solid #BDBBBB '
    },
    tableHeader: {
        textDecoration: "underline",
        padding: "20px 0 0 25px",
        fontSize: "20px",
        fontWeight: 500,
    },
    tableSubHeader: {
        padding: "20px 0 30px 25px",
        fontSize: "16px",
    },
    roleTable: {
        minHeight:'150px',
        margin:'0px 25px',
        border: "1px solid #BDBBBB",
        borderRadius: "7px",
    },
    roleTableHeader: {
        height: "35px",
        color: "#fff",
        padding: "7px 20px",
        backgroundColor: "#001128",
        borderRadius:'6px 6px 0px 0px'
    },
    roleTableBody: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "flex-start",
    },
    chips: {
        //display:'flex',
       // justifyContent:'space-evenly',
       minHeight:'150px',
        padding:'20px'
    },
    
});


function RoleDetails(props) {
    const classes = useStyles();

    const { t } = useTranslation();
    return (
        <Paper className={classes.table} data-test="license-detail-comp">
            <Box className={classes.tableHeader}>
                {t("CONTENT.ROLE.ROLE-DETAILS")}
            </Box>
            <Box className={classes.tableSubHeader}>
                {t('CONTENT.ROLE.ROLE-SUB-HEADER')}
            </Box>
            <Paper className={classes.roleTable}>
                <Box className={classes.roleTableHeader}>{t('CONTENT.ROLE.ASSIGNED-ROLES')}</Box>
                    <Box className={classes.chips}>
                        <Chips roles={props.roles} setRoles={props.setRoles} user={props.user}/>
                    </Box>
            </Paper>
        </Paper>
        
    );
}

export default RoleDetails;
